<template>
  <div class="teacher-reg">
	<!-- 顶部导航 -->
	<div class="login-top">
		<div class="logo">
			<div class="logo-badge">
				<img src="/logo.png" alt="Logo" class="logo-img">
			</div>
			<div class="logo-text">
				<div class="logo-name">青少年人工智能高水平创新人才培养 课程平台</div>
				<div class="logo-slogan">Youth AI High-Level Innovative Talent Training</div>
			</div>
		</div>
		<div class="btns">
			<div class="btn-pill-outline" @click="toRegister">学生注册</div>
			<div class="btn-grad btn-grad-sm" @click="toLogin">去登录</div>
		</div>
	</div>
	<!-- 品牌横幅 -->
	<div class="banner">
		<div class="deco deco-1"></div>
		<div class="deco deco-2"></div>
		<div class="deco-ring"></div>
		<div class="banner-content">
			<div class="huanying">欢迎你的加入！</div>
			<div class="huanying1">在这里，你将带领孩子们走进人工智能与编程的奇妙世界，</div>
			<div class="huanying1">用知识点亮每一个孩子的创造力和未来。</div>
			<div class="banner-points">
				<div class="banner-point"><i class="el-icon-office-building"></i>认证教师入驻</div>
				<div class="banner-point"><i class="el-icon-notebook-2"></i>自主创建课程</div>
				<div class="banner-point"><i class="el-icon-s-custom"></i>管理你的班级</div>
			</div>
		</div>
	</div>
	<!-- 入驻表单 -->
	<div class="teacherFrom">
		<div class="ruzhu-card">
			<div class="ruzhu-title">
				<div class="ruzhu-title-bar"></div>
				<div>
					<div>教师入驻信息</div>
					<div class="ruzhu-title-sub">请如实填写以下信息，平台审核通过后即可开课</div>
				</div>
			</div>
			<el-form :model="form" :rules="rules" ref="ruleForm" label-width="0px" class="ruzhu-form">
				<div class="form-grid">
					<el-form-item prop="userName" class="grid-item">
						<div class="item-title"><i class="el-icon-user"></i>姓名</div>
						<el-input v-model="form.userName" placeholder="请输入姓名"></el-input>
					</el-form-item>
					<el-form-item prop="loginAccount" class="grid-item">
						<div class="item-title"><i class="el-icon-postcard"></i>登录账号</div>
						<el-input v-model="form.loginAccount" placeholder="请输入登录账号"></el-input>
					</el-form-item>
					<el-form-item prop="password" class="grid-item">
						<div class="item-title"><i class="el-icon-lock"></i>密码</div>
						<el-input type="password" v-model="form.password" placeholder="请输入密码"></el-input>
					</el-form-item>
					<el-form-item prop="passwordNew" class="grid-item">
						<div class="item-title"><i class="el-icon-key"></i>确认密码</div>
						<el-input type="password" v-model="form.passwordNew" placeholder="请再次输入密码"></el-input>
					</el-form-item>
					<el-form-item prop="email" class="grid-item">
						<div class="item-title"><i class="el-icon-message"></i>邮箱</div>
						<el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
					</el-form-item>
					<el-form-item prop="tel" class="grid-item">
						<div class="item-title"><i class="el-icon-phone"></i>联系方式</div>
						<el-input v-model="form.tel" placeholder="请输入联系方式"></el-input>
					</el-form-item>
					<el-form-item prop="country" class="grid-item">
						<div class="item-title"><i class="el-icon-location"></i>国家</div>
						<el-select v-model="form.country" placeholder="请选择国家">
							<el-option label="中国" value="中国"></el-option>
							<el-option label="日本" value="日本"></el-option>
							<el-option label="韩国" value="韩国"></el-option>
							<el-option label="美国" value="美国"></el-option>
							<el-option label="俄罗斯" value="俄罗斯"></el-option>
							<el-option label="印度" value="印度"></el-option>
							<el-option label="巴西" value="巴西"></el-option>
							<el-option label="新加坡" value="新加坡"></el-option>
							<el-option label="加拿大" value="加拿大"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="sex" class="grid-item">
						<div class="item-title"><i class="el-icon-s-custom"></i>性别</div>
						<el-select v-model="form.sex" placeholder="请选择性别">
							<el-option label="男" value="0"></el-option>
							<el-option label="女" value="1"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="school" class="grid-item">
						<div class="item-title"><i class="el-icon-school"></i>院校</div>
						<el-select v-model="form.school" placeholder="请选择院校">
							<el-option v-for="(item,index) in school" :key="index" :label="item.name" :value="item.name"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="grade" class="grid-item">
						<div class="item-title"><i class="el-icon-reading"></i>年级</div>
						<el-select v-model="form.grade" placeholder="请选择任教年级">
							<el-option v-for="(item,index) in gradeList" :key="index" :label="item.dictLabel" :value="item.dictValue"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="agree" class="grid-item">
						<div class="item-title"><i class="el-icon-medal"></i>职称</div>
						<el-select v-model="form.agree" placeholder="请选择职称">
							<el-option label="初级讲师" value="初级讲师"></el-option>
							<el-option label="中级讲师" value="中级讲师"></el-option>
							<el-option label="高级讲师" value="高级讲师"></el-option>
							<el-option label="副教授" value="副教授"></el-option>
							<el-option label="教授" value="教授"></el-option>
							<el-option label="院士" value="院士"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="age" class="grid-item">
						<div class="item-title"><i class="el-icon-date"></i>年龄</div>
						<el-input type="number" v-model="form.age" placeholder="请输入年龄"></el-input>
					</el-form-item>
					<el-form-item prop="birth" class="grid-item">
						<div class="item-title"><i class="el-icon-present"></i>生日</div>
						<el-date-picker
							v-model="form.birth"
							type="date"
							style="width:100%"
							placeholder="请选择生日">
						</el-date-picker>
					</el-form-item>
					<el-form-item prop="workDate" class="grid-item">
						<div class="item-title"><i class="el-icon-time"></i>教龄（年）</div>
						<el-input type="number" v-model="form.workDate" placeholder="请输入教龄"></el-input>
					</el-form-item>
				</div>
				<el-form-item prop="address">
					<div class="item-title"><i class="el-icon-house"></i>地址</div>
					<el-input type="textarea" rows="3" v-model="form.address" placeholder="请输入详细地址"></el-input>
				</el-form-item>
				<el-form-item prop="flair">
					<div class="item-title"><i class="el-icon-picture-outline"></i>教学资质</div>
					<el-upload
						:file-list="fileList"
						ref="upload"
						:action="uploadImageUrl()" :headers="uploadHeaders()"
						accept="image/*"
						:multiple="false"
						:limit="1"
						:before-upload="beforeAvatorUpload"
						list-type="picture-card"
						:on-preview="handlePictureCardPreview"
						:on-exceed="handleExceed"
						:on-success="handleAvatorSuccess"
						:on-remove="handleRemove">
						<i class="el-icon-plus"></i>
					</el-upload>
					<el-dialog :visible.sync="dialogVisible">
						<img width="100%" :src="dialogImageUrl" alt="">
					</el-dialog>
				</el-form-item>
				<el-form-item prop="remark">
					<div class="item-title"><i class="el-icon-chat-dot-round"></i>自我介绍</div>
					<el-input type="textarea" rows="6" v-model="form.remark" placeholder="介绍一下你的教学经历和擅长方向吧"></el-input>
				</el-form-item>
			</el-form>
			<div class="ruzhu">
				<div class="btn-grad ruzhu-btn" @click="toRuZhu()">提交入驻</div>
			</div>
		</div>
	</div>
	<bottomPage></bottomPage>
  </div>
</template>

<script>
  import {getApeSchoolList,getDictByCode,register} from '../../api/api' 
  import bottomPage from "../../components/bottom/login-bottom"
  import { mixin } from '../../minix/index';
  export default {
	mixins: [mixin],
	data() {
	  return{
		userInfo: {
			username: "",
			password: ""
		},
		school: [],
		gradeList: [],
		dialogImageUrl: '',
        dialogVisible: false,
		form: {
			userName: "",
			password: "",
			passwordNew: "",
			loginAccount: "",
			email: "",
			tel: "",
			sex: "0",
			country: "",
			school: "",
			grade: "",
			agree: "",
			age: "",
			birth: "",
			flair: "",
			address: "",
			workDate: "",
			remark: "",
			userType: 1,
			status: 1,
		},
		fileList: [],
		rules: {
          userName: [
            { required: true, message: '请输入用户名', trigger: 'blur' },
          ],
          password: [
            { required: true, message: '请输入用户密码', trigger: 'blur' }
		  ],
		  passwordNew: [
            { required: true, message: '请输入确认密码', trigger: 'blur' }
		  ],
		  loginAccount: [
            { required: true, message: '请输入登陆账号', trigger: 'blur' }
		  ],
		  email: [
            { required: true, message: '请输入邮箱', trigger: 'blur' }
		  ],
		  tel: [
            { required: true, message: '请输入联系方式', trigger: 'blur' }
		  ],
		  sex: [
            { required: true, message: '请选择性别', trigger: 'blur' }
		  ],
		  country: [
            { required: true, message: '请选择国家', trigger: 'blur' }
		  ],
		  school: [
            { required: true, message: '请选择院校', trigger: 'blur' }
		  ],
		  grade: [
            { required: true, message: '请选择年级', trigger: 'blur' }
		  ],
		  agree: [
            { required: true, message: '请选择职称', trigger: 'blur' }
		  ],
		  age: [
            { required: true, message: '请输入年龄', trigger: 'blur' }
		  ],
		  birth: [
            { required: true, message: '请输入出生日期', trigger: 'blur' }
		  ],
		  address: [
            { required: true, message: '请输入地址', trigger: 'blur' }
		  ],
		  workDate: [
            { required: true, message: '请输入教龄', trigger: 'blur' }
		  ],
		  flair: [
            { required: true, message: '请上传教学资质', trigger: 'blur' },
          ],
		  remark: [
            { required: true, message: '请输入自我介绍', trigger: 'blur' }
          ],
        }
	  }
	},
	components: {
        bottomPage
	},
	methods: {
		handleAvatorSuccess(res) {
			let _this = this;
			if(res.code == 1000){
				_this.$message({
				type: 'success',
				message: '上传成功!'
				});
				this.fileList.push({url:this.$store.state.HOST + res.message})
				this.form.flair = res.message
			}else{
			_this.$notify.error({
				title: '错误',
				message: res.message
			});
			}
		},
		handleRemove(file, fileList) {
			this.form.flair = ""
			this.fileList = []
		},
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url;
			this.dialogVisible = true;
		},
		getApeSchoolList() {
			getApeSchoolList().then(res=> {
			if(res.code == 1000) {
				this.school = res.data
			} else {
				this.$notify.error({
				title: '错误',
				message: res.message
				});
			}
			})
		},
		loadGrades() {
			getDictByCode({code: 'grade'}).then(res => {
			if(res.code == 1000) {
				this.gradeList = res.data
			} else {
				this.$notify.error({
				title: '错误',
				message: res.message
				});
			}
			})
		},
		toRegister() {
			this.$router.push("/register")
		},
		toLogin() {
			this.$router.push("/login")
		},
		toRuZhu() {
			this.$refs["ruleForm"].validate((valid) => {
				if (valid) {
					if (this.form.passwordNew != this.form.password) {
						this.$message({
							message: '两次输入的密码不一致！',
							type: 'warning'
						});
						return;
					}
					if (this.fileList.length <= 0) {
						this.$message({
							message: '请上传教学资质！',
							type: 'warning'
						});
						return;
					}
					register(this.form).then(res => {
						if(res.code == 1000) {
							this.$message({
								message: '入驻成功,请等待平台审核',
								type: 'success'
							});
							var that = this
							setTimeout(function() {
								that.$router.push("/login")
							},500)
						} else {
							this.$message.error(res.message);
						}
					})
				} else {
					return false;
				}
			});
		}
	},
	created() {
	 
	},
	mounted() {
	  this.getApeSchoolList()
	  this.loadGrades()
	}
 }
</script>

<style scoped>
  .teacher-reg {
	  width: 100%;
	  min-height: 100%;
	  display: flex;
	  flex-direction: column;
	  background: var(--bg-page);
  }
  /* 顶部导航 */
  .login-top {
	  height: 84px;
	  display: flex;
	  align-items: center;
	  justify-content: space-between;
	  padding: 0 60px;
	  flex-shrink: 0;
  }
  .logo { display: flex; align-items: center; }
  .logo-badge {
	  width: 48px;
	  height: 48px;
	  border-radius: 14px;
	  background: #FFFFFF;
	  display: flex;
	  align-items: center;
	  justify-content: center;
	  box-shadow: 0 6px 16px rgba(91, 108, 255, 0.35);
	  overflow: hidden;
  }
  .logo-img {
	  width: 100%;
	  height: 100%;
	  object-fit: cover;
	  border-radius: 14px;
  }
  .logo-text { margin-left: 12px; }
  .logo-name {
	  font-size: 20px;
	  font-weight: 700;
	  background: var(--grad-primary);
	  -webkit-background-clip: text;
	  background-clip: text;
	  color: transparent;
	  letter-spacing: 1px;
  }
  .logo-slogan {
	  margin-top: 2px;
	  font-size: 12px;
	  color: var(--text-sub);
  }
  .btns { display: flex; align-items: center; gap: 16px; }
  .btn-grad-sm {
	  height: 40px;
	  padding: 0 26px;
	  font-size: 15px;
	  letter-spacing: 2px;
  }
  /* 品牌横幅 */
  .banner {
	  position: relative;
	  margin: 0 60px;
	  border-radius: var(--radius-lg);
	  background: var(--grad-hero);
	  overflow: hidden;
  }
  .banner-content {
	  position: relative;
	  z-index: 2;
	  text-align: center;
	  padding: 60px 20px 70px;
	  color: #FFFFFF;
  }
  .huanying {
	  font-size: 44px;
	  font-weight: 700;
	  letter-spacing: 3px;
	  margin-bottom: 20px;
  }
  .huanying1 {
	  font-size: 16px;
	  line-height: 2;
	  color: rgba(255, 255, 255, 0.88);
	  letter-spacing: 1px;
  }
  .banner-points {
	  margin-top: 28px;
	  display: flex;
	  justify-content: center;
	  gap: 16px;
  }
  .banner-point {
	  display: flex;
	  align-items: center;
	  gap: 8px;
	  padding: 10px 22px;
	  border-radius: 999px;
	  background: rgba(255, 255, 255, 0.15);
	  border: 1px solid rgba(255, 255, 255, 0.25);
	  font-size: 14px;
	  letter-spacing: 1px;
  }
  .banner-point i { color: #FFE066; font-size: 16px; }
  .deco { position: absolute; border-radius: 50%; z-index: 1; }
  .deco-1 {
	  width: 320px; height: 320px; right: -80px; top: -110px;
	  background: radial-gradient(circle, rgba(255,255,255,0.16) 0%, rgba(255,255,255,0) 70%);
  }
  .deco-2 {
	  width: 260px; height: 260px; left: -60px; bottom: -110px;
	  background: radial-gradient(circle, rgba(255, 224, 102, 0.20) 0%, rgba(255,255,255,0) 70%);
  }
  .deco-ring {
	  position: absolute;
	  width: 120px; height: 120px; right: 140px; top: 30px;
	  border: 12px solid rgba(255, 255, 255, 0.10);
	  border-radius: 50%;
	  z-index: 1;
  }
  /* 表单卡片 */
  .teacherFrom {
	  width: 100%;
	  display: flex;
	  justify-content: center;
	  padding: 50px 0 70px;
  }
  .ruzhu-card {
	  width: 66%;
	  background: #FFFFFF;
	  border-radius: var(--radius-lg);
	  box-shadow: var(--shadow-card);
	  padding: 50px 70px;
	  margin-top: -40px;
	  position: relative;
	  z-index: 3;
  }
  .ruzhu-title {
	  display: flex;
	  align-items: center;
	  margin-bottom: 40px;
  }
  .ruzhu-title-bar {
	  width: 8px;
	  height: 44px;
	  border-radius: 4px;
	  background: var(--grad-primary);
	  margin-right: 14px;
	  flex-shrink: 0;
  }
  .ruzhu-title > div:last-child > div:first-child {
	  font-size: 26px;
	  font-weight: 700;
	  color: var(--text-main);
	  letter-spacing: 2px;
  }
  .ruzhu-title-sub {
	  margin-top: 6px;
	  font-size: 13px;
	  color: var(--text-sub);
  }
  .form-grid {
	  display: flex;
	  flex-wrap: wrap;
	  gap: 0 24px;
  }
  .grid-item {
	  width: calc(50% - 12px);
  }
  .item-title {
	  font-size: 14px;
	  font-weight: 600;
	  color: var(--text-main);
	  margin-bottom: 8px;
	  letter-spacing: 1px;
  }
  .item-title i {
	  color: var(--primary);
	  margin-right: 6px;
	  font-size: 15px;
  }
  .ruzhu-form >>> .el-select { width: 100%; }
  .ruzhu-form >>> .el-date-editor { width: 100%; }
  .ruzhu-form >>> .el-form-item { margin-bottom: 24px; }
  .ruzhu {
	  display: flex;
	  justify-content: center;
	  margin-top: 20px;
  }
  .ruzhu-btn {
	  width: 240px;
  }
</style>
